module.exports = __webpack_public_path__ + "img/error-exclamation-mark.b373f6c3.svg";